import React, { useEffect } from "react";
import useRevisionSave from "components/brief/reviewer/revision/RevisionForm.lib.save";
import RevisionFormLayout from "components/brief/reviewer/revision/layout/RevisionFormLayout";
import { useDraft } from "components/brief/util/hooks/useDraft";
import { RevisionFormProvider, useRevisionFormContext } from "components/brief/reviewer/revision/RevisionForm.lib.context";

const RevisionForm = (props) => (
  <RevisionFormProvider {...props}>
    <RevisionFormContent
      onUpdate={props.onUpdate}
      onPublishedRevision={props.onPublishedRevision}
      extraActions={props.extraActions}
    />
  </RevisionFormProvider>
);

const RevisionFormContent = ({
  onUpdate,
  onPublishedRevision,
  extraActions,
}) => {

  const {
    flow,
    revisionId,
    currentMainTab,
    isDeveloper,
    allowComments,
    content,
    proposal,
    selectedProposalIndex,
    onClickEditProposal,
    onCreatedDevRevision,
  } = useRevisionFormContext();

  const showProposalActions = isDeveloper && !!revisionId && !!onClickEditProposal;
  const { draftRevisionId, initDraft, saveDraft } = useDraft({ flow, revisionId, isDeveloper });

  const onClickSaveDraft = () =>
    saveDraft("proposals", content.proposals);

  const {
    saveRevisionForm,
    isCreatingDevRevision,
    isSaving,
    onClickSaveRevision,
    onCloseSaveRevisionForm,
    onSubmitSaveRevisionForm,
  } = useRevisionSave({
    flow,
    revisionId,
    draftRevisionId,
    content,
    contentWithAnnotations: content,
    globalAdditionalComments: proposal.additional_comments || "",
    selectedProposalIndex,
    isDeveloper,
    currentMainTab,
    onUpdate,
    onPublishedRevision,
    onCreatedDevRevision,
  });

  useEffect(() => {
    if (allowComments) initDraft();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <RevisionFormLayout
      saveRevisionForm={saveRevisionForm}
      showProposalActions={showProposalActions}
      isCreatingDevRevision={isCreatingDevRevision}
      onClickSaveRevision={onClickSaveRevision}
      isSaving={isSaving}
      onCloseSaveRevisionForm={onCloseSaveRevisionForm}
      onSubmitSaveRevisionForm={onSubmitSaveRevisionForm}
      onClickSaveDraft={onClickSaveDraft}
      extraActions={extraActions}
    />
  );
};
export default RevisionForm;
